import PropTypes from 'prop-types'
import moment from 'moment'

import Icon from '../Icons'

const iconSize = {
  width: '20px',
  height: '20px',
}

const MobilePreviewContainer = ({ children, hideAppBar = false, additionalImg = null }) => {
  return (
    <div className="mobile-preview">
      <div className="preview-content">
        {!hideAppBar && (
          <div className="app-bar">
            <div>{moment().format('HH:mm')}</div>
            <div>
              <Icon icon="cellular" fill="white" styles={iconSize} />
              <Icon icon="wifi" fill="white" styles={iconSize} />
              <Icon icon="battery" fill="white" viewBox="0 0 25 25" styles={iconSize} />
            </div>
          </div>
        )}
        {children}
      </div>
      <img src="/images/iphone-preview.png" />
      {additionalImg}
    </div>
  )
}

MobilePreviewContainer.propTypes = {
  children: PropTypes.node,
  hideAppBar: PropTypes.bool,
  additionalImg: PropTypes.node,
}

export default MobilePreviewContainer
